import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Form from "../common/Form";
import InitiatievenFormItem from "./formitems/InitiatievenFormItem";
import HoofdzetelFormItem from "./formitems/HoofdzetelFormItem";
import ContactPersoonFormItem from "./formitems/ContactPersoonFormItem";
import AanvraagAdresFormItem from "./formitems/AanvraagAdresFormItem";
import OpmerkingFormItem from "./formitems/OpmerkingFormItem";
import WerkInformatieFormItem from "./formitems/WerkInformatieFormItem";

const SportenOpHetWerkForm = (props) => {
    const {
        model,
        onChange,
        onChangeInitiatieven,
        onChangeHoofdZetel,
        onChangeHoofdzetelAdres,
        onChangeCheckbox,
        onChangeAanvraagAdres,
        onChangeContactPersoon,
        onChangeBedrijfInfo,
        onSave,
        errors
    } = props;


    return (
        <div>
            <Fragment>
                <Form name="Sporten op het werk"
                    title={"Aanvraagformulier 'Sport op het Werk'-initiatief"}
                    onLeftButtonClick={onSave}
                    leftButtonLabel={"Verzend"}
                    isNotRequired
                    headerVisible>
                    <InitiatievenFormItem
                        model={model}
                        onChange={onChangeInitiatieven}
                        errors={errors}
                    />
                    <HoofdzetelFormItem
                        model={model.hoofdzetel}
                        onChange={onChangeHoofdZetel}
                        onChangeHoofdzetelAdres={onChangeHoofdzetelAdres}
                        errors={errors}
                    />
                    <AanvraagAdresFormItem
                        model={model.aanvraagAdresVestiging}
                        onChange={onChangeCheckbox}
                        onChangeAanvraagAdres={onChangeAanvraagAdres}
                        errors={errors}
                    />
                    <ContactPersoonFormItem
                        model={model.contactPersoon}
                        onChange={onChangeContactPersoon}
                        errors={errors}
                    />
                    <WerkInformatieFormItem
                        model={model.bedrijfInfo}
                        onChange={onChangeBedrijfInfo}
                        errors={errors}
                    />
                    <OpmerkingFormItem
                        model={model}
                        onChange={onChange}
                        errors={errors}
                    />
                </Form>
            </Fragment>
        </div>
    );
};

SportenOpHetWerkForm.propTypes = {
    model: PropTypes.object,
    onChange: PropTypes.func,
    onChangeInitiatieven: PropTypes.func,
    onChangeHoofdZetel: PropTypes.func,
    onChangeHoofdzetelAdres: PropTypes.func,
    onChangeCheckbox: PropTypes.func,
    onChangeAanvraagAdres: PropTypes.func,
    onChangeContactPersoon: PropTypes.func,
    onChangeBedrijfInfo: PropTypes.func,
    onSave: PropTypes.func,
    errors: PropTypes.array
};

export default SportenOpHetWerkForm;